export default __webpack_public_path__ + "cd6210c358fc881dad7cdbd4e2134a0f.png";